module.exports = __webpack_public_path__ + "img/rm.791e3b14.svg";